export const DIRECT_UPLOAD_URL = `${process.env.REACT_APP_NEW_API_URL}/bucket/storage/direct_uploads`
export const MAX_ALLOWED_BYTES = 10485760 // 10 MB
const invalidExtensionError = {
  code: 'invalid-extension',
  message: 'File must have .pdf, .doc/.docx or .jpg/.jpeg/.png extension'
}
export const fileExtensionValidator = (file) => {
  const filename = file?.name || ''
  const lastDotIndex = filename.lastIndexOf('.')
  if (lastDotIndex <= 0) return invalidExtensionError
  const extension = filename.slice(lastDotIndex + 1).toLowerCase()
  const allowedExtensions = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png']
  if (allowedExtensions.includes(extension)) return null
  return invalidExtensionError
}
